<span *ngIf="loading; else dealOwner" class="loading-container">
  <mat-spinner diameter="24" class="loading-deal-owner"></mat-spinner>
  <div class="loading-text">Loading Deal Owner...</div>
</span>
 <ng-template #dealOwner>
  <div class="deal-owner-row" [class.advanced-deal]="advancedDeal">
    <h2 class="mb-0">Owner</h2>
  </div>
  <div class="deal-owner-row" [class.advanced-deal]="advancedDeal">
    <div *ngIf="editing; else owner">
      <formly-form
        [form]="editDealOwnerForm"
        [fields]="fields"
        [model]="model"
        data-cy="formly-owner-select">
      </formly-form>
    </div>
    <ng-template #owner>
      <h4 class="mb-0" *ngIf="deal.lender_user" data-cy="deal-owner-name">{{ deal.lender_user.fullName }}</h4>
      <div class="deal-owner-edit">
        <button
          *ngIf="!editing && canManageDeals && !readOnly"
          mat-button
          color="primary"
          (click)="openDialog()"
          data-cy="edit-owner-button"
          >
          Edit Owner
        </button>
        <button
          *ngIf="editing"
          mat-button
          color="primary"
          (click)="editing = false">
          Cancel Edit
        </button>
      </div>
    </ng-template>
  </div>
</ng-template>
